import React, { useEffect, useState, useMemo } from 'react'
import * as Styles from './style'
import { Formik, Field, FieldArray } from 'formik'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify'
import close from '../../../assets/images/close.png'
import { InputGroup } from '../../../shared/InputGroup/InputGroup'
import { TextareaGroup } from '../../../shared/TextareaGroup/TextareaGroup'
import CheckboxGroup from '../../../shared/CheckboxDropDown/CheckBoxGroup'
import {
  BEE_Array,
  DUMMY_FARMERS,
  DUMMY_HONEY_TYPES,
  ORDER_STATUS_ARRAY,
  monthsOfYear,
  monthsOfYearWithLabels,
} from '../../../shared/Constants/Constants'
import {
  getRandomAlphabets,
  generateId,
  changeDateTimeFormat,
} from '../../../shared/Helper'
import {
  makeBatch,
  resetErrorinMakeBatch,
  resetMessageinMakeBatch,
} from '../../../reduxLogic/reducers/batches/makeBatchSlice'
//@ts-ignore
import { getAllBatches } from '../../../reduxLogic/reducers/batches/getAllBatchesSlice'
import { getAllFarmers } from '../../../reduxLogic/reducers/farmers/getAllFarmersSlice'
import { FieldErrorMessage } from '../../../shared/ErrorMessage/FieldErrorMessage'
import { MultiSelect } from 'react-multi-select-component'
import { getAllHoney } from '../../../reduxLogic/reducers/honeys/getAllHoneySlice'
import { renderPreviewForCurrent } from '../../../shared/RenderPreview/RenderPreview'
import LabelValueCheckBox from '../../../shared/LabelValueCheckBox/LabelValueCheckBox'
import Swal from 'sweetalert2'
import { getAllApiariesService, getHarvests } from '../../../../../../services/apiaryService'
import { Select as AntSelect } from 'antd'
import moment from 'moment'

const { Option } = AntSelect;

const batchSchema = Yup.object().shape({
  supplier: Yup.string().required('Supplier Name is required'),
  orderStatus: Yup.string().required('Order Status  is required'),
  dateOfOrder: Yup.string().required('Date of Order is required'),
  //dateOfDelivery: Yup.string().required("Date of Delivery is required"),
  nectorSource: Yup.string().required('Nector Source is required'),
  origin: Yup.string().required('Origin is required'),
  batchItems: Yup.array()
    .of(
      Yup.object().shape({
        honeyType: Yup.string().required('Honey Type is required'),
        volume: Yup.string().required('Volume is required'),
      })
    )
    .min(1, 'At least one batch item is required'),
})

const initialValues = {
  supplier: '',
  dateOfOrder: '',
  dateOfDelivery: '',
  batchItems: [{ honeyType: '', volume: '', contributingFarmers: [], bee: '' }],
  currentToken: '',
  nectorSource: '',
  origin: '',
  harvestPeriod: [],
  orderStatus: '',
  batchDocuments: [],
  apiaryId: '',
  selectedHarvestIds: []
}

export const BatchForm = props => {
  const { openModal, setOpenModal } = props
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [selectedHarvestPeriod, setSelectedHarvestPeriod] = useState([])
  const [allBatchDocuments, setAllBatchDocuments] = useState([])
  const [apiaries, setApiaries] = useState([])
  const [availableHarvests, setAvailableHarvests] = useState([])
  const [harvestLoading, setHarvestLoading] = useState(false)
  const [globalHarvests, setGlobalHarvests] = useState([])
  const [globalHarvestsLoading, setGlobalHarvestsLoading] = useState(false)

  const { farmersData } = useSelector(state => state.allFarmers)
  const { suppliersData } = useSelector(state => state.allSuppliers)
  const { batchData } = useSelector(state => state.allBatches)

  // const farmerNamesArray = farmersData.map((farmer) => ({
  //   label: farmer.farmerName,
  //   value: farmer._id,
  // }));
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllHoney())
    dispatch(getAllBatches())
    getAllApiariesService().then(data => setApiaries(data || []))

    setGlobalHarvestsLoading(true)
    getHarvests(null)
      .then(data => {
        setGlobalHarvests(data || [])
        setGlobalHarvestsLoading(false)
      })
      .catch(err => {
        console.error('Error fetching harvests:', err)
        setGlobalHarvestsLoading(false)
      })
  }, [])

  const { error, message } = useSelector(state => state.makeBatch)
  console.log('this is message immedaitely after useSelector => ', message)
  console.log('this is error immedaitely after useSelector => ', error)

  const { honeyData } = useSelector(state => state.allHoneys)

  const newHoneyArray = honeyData?.map(item => ({
    label: `${item.honeyId}-${item.floralSource}`,
    value: item._id,
  }))

  console.log('newHoneyArray ======>> ', newHoneyArray)

  const unbatchedHarvests = useMemo(() => {
    if (!globalHarvests) return []
    const linkedHarvestIds = new Set()
    if (batchData && Array.isArray(batchData)) {
      batchData.forEach(batch => {
        if (batch.harvestIds && Array.isArray(batch.harvestIds)) {
          batch.harvestIds.forEach(id => linkedHarvestIds.add(id))
        }
      })
    }
    return globalHarvests.filter(h => !linkedHarvestIds.has(h.harvest_id))
  }, [globalHarvests, batchData])

  const handleClose = () => {
    setOpenModal(false)
  }

  const handleBatchDocumentsChange = (e, index) => {
    const { files } = e.target
    setAllBatchDocuments(prev => [...prev, ...files])
  }

  const handleClearSelection = e => {
    e.preventDefault()
    const fileInput = document.querySelector('input[name="batchDocuments"]')
    if (fileInput) {
      fileInput.value = null
    }
    setAllBatchDocuments([])
  }

  const handleSubmit = values => {
    console.log('this is handleSubmit Values : ', values)
    setIsSubmitting(true)
    const token = localStorage.getItem('humblebeeAuthToken')
    let formData = new FormData()

    formData.append('supplier', values.supplier)
    formData.append('orderStatus', values.orderStatus)

    formData.append('dateOfOrder', values.dateOfOrder)

    formData.append('dateOfDelivery', values.dateOfDelivery)
    formData.append('currentToken', token)

    values.batchItems.forEach((batchItem, index) => {
      const { honeyType, volume, contributingFarmers, bee } = batchItem

      formData.append(`batchItems[${index}].honeyType`, honeyType)
      formData.append(`batchItems[${index}].volume`, volume)

      formData.append(`batchItems[${index}].bee`, bee)

      // Append contributingFarmers as separate properties
      contributingFarmers.forEach((contributingFarmer, i) => {
        formData.append(
          `batchItems[${index}].contributingFarmers[${i}]`,
          contributingFarmer
        )
      })
    })

    if (values.selectedHarvestIds && values.selectedHarvestIds.length > 0) {
      values.selectedHarvestIds.forEach((id, index) => {
        formData.append(`harvestIds[${index}]`, id)
      })
    }

    let harvestMonths = selectedHarvestPeriod.map(item => item.value)

    harvestMonths.forEach((item, index) => {
      formData.append(`harvestPeriod[${index}]`, item)
    })

    formData.append('nectorSource', values.nectorSource)

    formData.append('origin', values.origin)

    for (let i = 0; i < allBatchDocuments?.length; i++) {
      formData.append(`batchDocuments[${i}]`, allBatchDocuments[i])
    }

    if (values.supplier == 'Select Supplier') {
      toast.error('Invalid Supplier')
      return
    }
    // const tempValues = {
    //   supplier: values.supplier,
    //   dateOfOrder: values.dateOfOrder,
    //   dateOfDelivery: values.dateOfDelivery,
    //   currentToken: token,
    //   batchItems: values.batchItems,
    //   nectorSource: values.nectorSource,
    //   origin: values.origin,
    // };

    // console.log("tempValues => ", tempValues);

    // if (values?.dateOfDelivery < values?.dateOfOrder) {
    //   toast.error("Date of Delivery must come after Date of Order");
    //   return;
    // }

    dispatch(makeBatch(formData))
      .then(() => setOpenModal(false))
      .then(() => dispatch(getAllBatches()))
      .then(() => setIsSubmitting(false))
  }

  useEffect(() => {
    dispatch(getAllFarmers())
  }, [])

  useEffect(() => {
    if (error) {
      console.log('inside error condition of toast', error)
      toast.error(`${error}`)
      dispatch(resetErrorinMakeBatch())
      dispatch(resetMessageinMakeBatch())
    }

    if (!error && message) {
      console.log('inside not error condition of toast', message)
      toast.success('Batch was added succesfully')
      dispatch(resetMessageinMakeBatch())
    }
  }, [error, dispatch, message])

  return (
    <Styles.ModalWrapper>
      <Styles.ModalContent>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={batchSchema}
          validateOnMount
        >
          {formik => (
            <Styles.FormWithCloseButton>
              <Styles.CloseButtonDiv>
                <h3>Batch Form</h3>
                <Styles.FormCloseButton onClick={handleClose}>
                  <img src={close} alt="Close" />
                </Styles.FormCloseButton>
              </Styles.CloseButtonDiv>
              {/* Top Banner: Prefill Helper Panel */}
              <div style={{ 
                background: '#fff9db', 
                border: '1px solid #ffe066', 
                padding: '16px', 
                borderRadius: '8px',
                marginBottom: '15px'
              }}>
                <label style={{ color: '#f08c00', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                  Prefill from Unbatched Field Harvest {globalHarvestsLoading && <small>(Loading...)</small>}
                </label>
                <AntSelect
                  showSearch
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="Select a harvest to pre-fill the form"
                  optionFilterProp="children"
                  value={formik.values.selectedHarvestIds && formik.values.selectedHarvestIds.length === 1 ? formik.values.selectedHarvestIds[0] : undefined}
                  onChange={val => {
                    if (!val) {
                      formik.setFieldValue('apiaryId', '')
                      formik.setFieldValue('origin', '')
                      formik.setFieldValue('nectorSource', '')
                      if (formik.values.batchItems.length === 1) {
                        formik.setFieldValue('batchItems[0].volume', '')
                        formik.setFieldValue('batchItems[0].bee', '')
                      }
                      setSelectedHarvestPeriod([])
                      formik.setFieldValue('harvestPeriod', [])
                      formik.setFieldValue('selectedHarvestIds', [])
                      setAvailableHarvests([])
                      return
                    }

                    const harvest = unbatchedHarvests.find(h => h.harvest_id === val)
                    if (harvest) {
                      formik.setFieldValue('apiaryId', harvest.apiary_id)
                      const selectedApiary = apiaries.find(a => a.apiary_id === harvest.apiary_id)
                      if (selectedApiary) {
                        formik.setFieldValue('origin', selectedApiary.apiary_name)
                      } else {
                        formik.setFieldValue('origin', harvest.apiary_name || '')
                      }
                      
                      let nSource = ''
                      if (harvest.flowering_type && harvest.flowering_type.toLowerCase() === 'monofloral') {
                        let flowerName = ''
                        if (harvest.selected_flower) {
                          if (typeof harvest.selected_flower === 'object') {
                            flowerName = harvest.selected_flower.localName || harvest.selected_flower.plant || ''
                          } else if (typeof harvest.selected_flower === 'string') {
                            flowerName = harvest.selected_flower
                          }
                        }
                        nSource = flowerName ? `Monofloral (${flowerName})` : 'Monofloral'
                      } else if (harvest.flowering_type && harvest.flowering_type.toLowerCase() === 'multifloral') {
                        nSource = 'Multifloral'
                      } else {
                        nSource = harvest.flowering_type || ''
                      }
                      formik.setFieldValue('nectorSource', nSource)

                      if (formik.values.batchItems.length === 1) {
                        formik.setFieldValue('batchItems[0].volume', harvest.total_honey_kg || '')
                      }

                      let mappedBee = ''
                      if (harvest.bee_species) {
                        const hBee = harvest.bee_species.toLowerCase()
                        if (hBee.includes('mellifera')) {
                          mappedBee = 'Apis Mellifera'
                        } else if (hBee.includes('cerana') || hBee.includes('cerena')) {
                          mappedBee = 'Apis Cerena Indica'
                        } else if (hBee.includes('florea')) {
                          mappedBee = 'Apis Florea'
                        } else if (hBee.includes('dorsata')) {
                          mappedBee = 'Apis Dorsata'
                        } else if (hBee.includes('trigona') || hBee.includes('stingless')) {
                          mappedBee = 'Apis Trigona'
                        }
                      }
                      if (mappedBee && formik.values.batchItems.length === 1) {
                        formik.setFieldValue('batchItems[0].bee', mappedBee)
                      }

                      if (harvest.harvested_on) {
                        const monthName = moment(harvest.harvested_on).format('MMMM')
                        const monthOption = monthsOfYearWithLabels.find(m => m.value === monthName)
                        if (monthOption) {
                          setSelectedHarvestPeriod([monthOption])
                          formik.setFieldValue('harvestPeriod', [monthName])
                        }
                      }

                      formik.setFieldValue('selectedHarvestIds', [harvest.harvest_id])

                      setHarvestLoading(true)
                      getHarvests(harvest.apiary_id).then(data => {
                        setAvailableHarvests(data || [])
                        setHarvestLoading(false)
                      })
                    }
                  }}
                >
                  {unbatchedHarvests.map(h => (
                    <Option key={h.harvest_id} value={h.harvest_id}>
                      {h.harvest_id} | {moment(h.harvested_on).format('DD MMM YYYY')} | {h.total_honey_kg}kg | {h.flowering_type || 'N/A'}
                    </Option>
                  ))}
                </AntSelect>
              </div>

              {/* Main Fields Grid */}
              <Styles.FormGrid>
                {/* Row 1: Supplier and Order Status */}
                <Styles.FormGroupHalf>
                  <Styles.FieldArrayLabel htmlFor={formik.values.supplier}>
                    Supplier
                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                  </Styles.FieldArrayLabel>
                  <Styles.FieldArrayField
                    name="supplier"
                    as="select"
                    value={formik.values.supplier}
                    onChange={formik.handleChange}
                  >
                    <option hidden>Select Supplier</option>
                    {suppliersData.map((singleSupplier, index) => (
                      <option
                        value={singleSupplier._id}
                        key={singleSupplier.supplierId}
                      >
                        {singleSupplier.supplierName}
                      </option>
                    ))}
                  </Styles.FieldArrayField>
                  <FieldErrorMessage name="supplier" />
                </Styles.FormGroupHalf>

                <Styles.FormGroupHalf>
                  <Styles.FieldArrayLabel htmlFor={formik.values.orderStatus}>
                    Order Status
                    <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                  </Styles.FieldArrayLabel>
                  <Styles.FieldArrayField
                    name="orderStatus"
                    as="select"
                    value={formik.values.orderStatus}
                    onChange={formik.handleChange}
                  >
                    <option hidden>Select Order Status</option>
                    {ORDER_STATUS_ARRAY.map((status, index) => (
                      <option value={status} key={status}>
                        {status}
                      </option>
                    ))}
                  </Styles.FieldArrayField>
                  <FieldErrorMessage name="orderStatus" />
                </Styles.FormGroupHalf>

                {/* Row 2: Apiary and Link Field Harvests */}
                <Styles.FormGroupHalf>
                  <Styles.FieldArrayLabel>
                    Select Apiary (Origin)
                  </Styles.FieldArrayLabel>
                  <AntSelect
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Choose an Apiary"
                    optionFilterProp="children"
                    value={formik.values.apiaryId || undefined}
                    onChange={val => {
                      formik.setFieldValue('apiaryId', val);
                      const selectedApiary = apiaries.find(a => a.apiary_id === val);
                      if (selectedApiary) {
                          formik.setFieldValue('origin', selectedApiary.apiary_name);
                      }
                      setHarvestLoading(true);
                      getHarvests(val).then(data => {
                          setAvailableHarvests(data || []);
                          setHarvestLoading(false);
                      });
                    }}
                  >
                    {apiaries.map(a => (
                      <Option key={a.apiary_id} value={a.apiary_id}>
                        {a.apiary_name} ({a.apiary_id})
                      </Option>
                    ))}
                  </AntSelect>
                </Styles.FormGroupHalf>

                <Styles.FormGroupHalf>
                  {formik.values.apiaryId && (
                    <>
                      <Styles.FieldArrayLabel>
                        Link Field Harvests {harvestLoading && <small>(Loading...)</small>}
                      </Styles.FieldArrayLabel>
                      <AntSelect
                        mode="multiple"
                        style={{ width: '100%' }}
                        placeholder="Select Harvest Log to batch"
                        value={formik.values.selectedHarvestIds}
                        onChange={ids => {
                            formik.setFieldValue('selectedHarvestIds', ids);
                            const totalVol = availableHarvests
                              .filter(h => ids.includes(h.harvest_id))
                              .reduce((acc, curr) => acc + (curr.total_honey_kg || 0), 0);
                            
                            // Auto-populate batch volume if only one batch item exists
                            if (formik.values.batchItems.length === 1) {
                                formik.setFieldValue('batchItems[0].volume', totalVol);
                            }
                        }}
                      >
                        {availableHarvests.map(h => (
                          <Option key={h.harvest_id} value={h.harvest_id}>
                            {h.harvest_id} | {moment(h.harvested_on).format('DD MMM')} | {h.total_honey_kg}kg | {h.selected_flower}
                          </Option>
                        ))}
                      </AntSelect>
                      {formik.values.selectedHarvestIds.length > 0 && (
                        <div style={{ marginTop: '5px', fontSize: '12px', color: '#666' }}>
                          Linked Quantity: {availableHarvests.filter(h => formik.values.selectedHarvestIds.includes(h.harvest_id)).reduce((acc, curr) => acc + (curr.total_honey_kg || 0), 0)} kg
                        </div>
                      )}
                    </>
                  )}
                </Styles.FormGroupHalf>

                {/* Row 3: Order Date and Delivery Date */}
                <Styles.FormGroupHalf>
                  <InputGroup
                    PlaceholderText="Enter Order Date"
                    LabelText="Order Date"
                    name="dateOfOrder"
                    type="datetime-local"
                    star="*"
                    onChange={formik.handleChange}
                  />
                </Styles.FormGroupHalf>

                <Styles.FormGroupHalf>
                  {formik.values.orderStatus != 'Delivered' ||
                  formik.values.orderStatus == '' ? (
                    <InputGroup
                      PlaceholderText="Enter Delivery Date"
                      LabelText="Delivery Date"
                      name="dateOfDelivery"
                      type="datetime-local"
                      onChange={formik.handleChange}
                      isDisabled={true}
                    />
                  ) : (
                    <InputGroup
                      PlaceholderText="Enter Delivery Date"
                      LabelText="Delivery Date"
                      name="dateOfDelivery"
                      type="datetime-local"
                      star="*"
                      onChange={formik.handleChange}
                    />
                  )}
                </Styles.FormGroupHalf>

                {/* Row 4: Nector Source */}
                <Styles.FormGroupFull>
                  <TextareaGroup
                    PlaceholderText="Enter Nector Source"
                    LabelText="Nector Source"
                    name="nectorSource"
                    type="text"
                    star="*"
                    onChange={formik.handleChange}
                    value={formik.values.nectorSource}
                  />
                </Styles.FormGroupFull>

                {/* Row 5: Origin */}
                <Styles.FormGroupFull>
                  <TextareaGroup
                    PlaceholderText="Enter Origin"
                    LabelText="Origin"
                    name="origin"
                    type="text"
                    star="*"
                    onChange={formik.handleChange}
                    value={formik.values.origin}
                  />
                </Styles.FormGroupFull>

                {/* Row 6: Harvest Period */}
                <Styles.FormGroupFull>
                  <div style={{ marginTop: '10px' }}>
                    <label style={{ fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>
                      Harvest Period
                      <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                    </label>

                    <div style={{ marginTop: '5px' }}>
                      <MultiSelect
                        options={monthsOfYearWithLabels}
                        value={selectedHarvestPeriod}
                        onChange={setSelectedHarvestPeriod}
                        labelledBy="Select"
                      />
                    </div>

                    {selectedHarvestPeriod?.length <= 0 ? (
                      <span style={{ color: 'red', display: 'block', marginTop: '5px' }}>
                        There should be atleast one month selected
                      </span>
                    ) : null}
                  </div>
                </Styles.FormGroupFull>
              </Styles.FormGrid>

              <FieldArray name="batchItems">
                {arrayHelpers =>
                  formik.values.batchItems.map((batchItem, index) => (
                    <Styles.BatchItemsContainer2 key={index}>
                      <Styles.LabelFieldGroup>
                        <Styles.FieldArrayLabel htmlFor={batchItem.honeyType}>
                          Honey Type
                        </Styles.FieldArrayLabel>
                        <Styles.FieldArrayField
                          name={`batchItems[${index}].honeyType`}
                          as="select"
                          value={batchItem.honeyType}
                          onChange={formik.handleChange}
                        >
                          <option hidden>Select Honey Type</option>
                          {newHoneyArray?.map((singleHoneyType, index) => (
                            <option
                              value={singleHoneyType.value}
                              key={singleHoneyType.value}
                              style={{ padding: '4px' }}
                            >
                              {singleHoneyType.label}
                            </option>
                          ))}
                        </Styles.FieldArrayField>
                        <FieldErrorMessage
                          name={`batchItems.${index}.honeyType`}
                        />
                      </Styles.LabelFieldGroup>

                      <Styles.LabelFieldGroup>
                        <Styles.FieldArrayLabel
                          htmlFor={`batchItems[${index}].volume`}
                        >
                          Volume(kg)
                        </Styles.FieldArrayLabel>
                        <Styles.FieldArrayField
                          name={`batchItems[${index}].volume`}
                          type="number"
                          placeholder="Enter Volume"
                        />
                        <FieldErrorMessage
                          name={`batchItems.${index}.volume`}
                        />
                      </Styles.LabelFieldGroup>

                      {/* <Styles.LabelFieldGroup>
                        <Styles.FieldArrayLabel
                          htmlFor={`batchItems[${index}].contributingFarmers`}
                        >
                          Contributing Farmers
                        </Styles.FieldArrayLabel>
                        <Field
                          name={`batchItems.${index}.contributingFarmers`}
                          render={({ field }) => (
                            <>
                              <Styles.MultiSelectAllShowDiv>
                                {formik.values.batchItems[
                                  index
                                ].contributingFarmers.map(
                                  (singleFarmer, ind) => {
                                    // Find the farmer object with matching _id in farmersData array
                                    const farmer = farmersData.find(
                                      item => item._id === singleFarmer
                                    )

                                    // Check if farmer is found and retrieve the farmerName
                                    const farmerName = farmer
                                      ? farmer?.farmerName
                                      : singleFarmer

                                    return (
                                      <Styles.MultiSelectSingleShowDiv
                                        key={ind + Date.now()}
                                      >
                                        {farmerName}
                                      </Styles.MultiSelectSingleShowDiv>
                                    )
                                  }
                                )}
                              </Styles.MultiSelectAllShowDiv>

                              <CheckboxGroup
                                id={`batchItems.${index}.contributingFarmers`}
                                options={farmersData}
                                onChange={formik.handleChange}
                                name={`batchItems.${index}.contributingFarmers`}
                              />
                            </>
                          )}
                        />
                        <FieldErrorMessage
                          name={`batchItems.${index}.contributingFarmers`}
                        />
                      </Styles.LabelFieldGroup> */}

                      <Styles.LabelFieldGroup>
                        <Styles.FieldArrayLabel htmlFor={batchItem.bee}>
                          Bee
                        </Styles.FieldArrayLabel>
                        <Styles.FieldArrayField
                          name={`batchItems[${index}].bee`}
                          as="select"
                          value={batchItem.bee}
                          onChange={formik.handleChange}
                        >
                          <option hidden>Select Bee</option>
                          {BEE_Array.map((singleBee, index) => (
                            <option value={singleBee} key={singleBee}>
                              {singleBee}
                            </option>
                          ))}
                        </Styles.FieldArrayField>
                        <FieldErrorMessage name={`batchItems.${index}.bee`} />
                      </Styles.LabelFieldGroup>

                      {/* <Styles.AddRemoveButtonContainer>
                        <Styles.RemoveButton
                          type="button"
                          onClick={() => arrayHelpers.remove(index)}
                        >
                          <span>-</span>
                        </Styles.RemoveButton>
                        <Styles.AddButton
                          type="button"
                          onClick={() =>
                            arrayHelpers.push({
                              honeyType: "",
                              volume: "",
                              contributingFarmers: [],
                            })
                          }
                        >
                          <span>+</span>
                        </Styles.AddButton>
                      </Styles.AddRemoveButtonContainer> */}
                    </Styles.BatchItemsContainer2>
                  ))
                }
              </FieldArray>

              <Styles.ColumnFlex>
                <Styles.Labels>Batch Documents</Styles.Labels>
                <Styles.FileInputClearButtonDiv>
                  <button onClick={e => handleClearSelection(e)}>
                    <img src={close} alt="clear" />
                  </button>
                  <Styles.FileInput
                    type="file"
                    multiple
                    onChange={(e, index) =>
                      handleBatchDocumentsChange(e, index)
                    }
                    name="batchDocuments"
                    accept=".pdf, image/*"
                  />
                </Styles.FileInputClearButtonDiv>

                <Styles.IMGTextBox>
                  {/* <p>Current</p> */}
                  <Styles.IMGBox>
                    {allBatchDocuments && allBatchDocuments?.length > 0
                      ? allBatchDocuments?.map((item, index) => (
                          <div
                            key={index}
                            className="image"
                            style={{
                              height: '100px',
                              width: '120px',
                              display: 'flex',
                            }}
                          >
                            <div>{renderPreviewForCurrent(item, index)}</div>
                            <button
                              className="delete-button"
                              type="button"
                              onClick={() => {
                                Swal.fire({
                                  title: 'Delete Confirmation',
                                  text: 'Are you sure you want to delete this item?',
                                  icon: 'warning',
                                  showCancelButton: true,
                                  confirmButtonColor: 'rgb(255, 135, 1)',
                                  cancelButtonColor: 'lightgrey',
                                  confirmButtonText: 'Delete',
                                }).then(result => {
                                  if (result.isConfirmed) {
                                    // let filterImage = allMedia.filter((item,i) => i !== index );
                                    //                               setAllMedia(filterImage)

                                    let filterImage = allBatchDocuments.filter(
                                      (item, i) => i !== index
                                    )
                                    setAllBatchDocuments(filterImage)
                                    Swal.fire(
                                      'Deleted!',
                                      'The item has been deleted.',
                                      'success'
                                    )
                                  }
                                })
                              }}
                            >
                              <img
                                src={close}
                                alt="clear"
                                style={{ height: '10px' }}
                              />
                            </button>
                          </div>
                        ))
                      : null}
                  </Styles.IMGBox>
                </Styles.IMGTextBox>
              </Styles.ColumnFlex>

              <Styles.CreateBatchButton
                // disabled={!formik.dirty || !formik.isValid}
                type="submit"
              >
                {isSubmitting ? '...submitting' : 'Create'}
              </Styles.CreateBatchButton>
            </Styles.FormWithCloseButton>
          )}
        </Formik>
      </Styles.ModalContent>
    </Styles.ModalWrapper>
  )
}
